"use client";

import { ExclusiveAccess } from "@/components/ecommerce/exclusive-access/exclusive-access";
import { Button, ButtonVariant } from "@/components/ui/button";
import { createPath } from "@/service/routing/routing";
import { LockKeyholeOpenIcon, PlayIcon } from "lucide-react";
import { SuperLink as Link } from "@/components/common/super-link";
import { CourseCardCta } from "../course/course-card/components/course-card-cta";
import { FreebieButton } from "./freebie-button/freebie-button";
import { isDateInFuture } from "@/service/date/compare";
import { UserContext } from "@/contexts/user-context";
import { useContext } from "react";

export const ComplexBuyButton = ({
  product,
  isOwned,
  exclusiveAccess,
  publishedAt,
  slug,
  id,
  title,
  variant = "secondary",
  isFreebie,
}: {
  product?: ProductPriceOneVariantVM;
  isOwned: boolean;
  exclusiveAccess?: ExclusiveAccessVM;
  publishedAt: DateString;
  slug: string;
  id: string;
  title: string;
  variant?: ButtonVariant;
  isFreebie: boolean;
}) => {
  const { isLoggedIn } = useContext(UserContext);

  const preorder = isDateInFuture(publishedAt);
  const canBeBought = !isFreebie && !exclusiveAccess;

  if (!isLoggedIn) {
    return (
      <Button asChild className="mt-4 w-full" variant={variant}>
        <a href={createPath("security.login")}>
          {isFreebie ? "Zaloguj się, aby odblokować" : "Zaloguj się, aby kupić"}
        </a>
      </Button>
    );
  }

  if (isOwned) {
    return (
      <Button asChild className="mt-4 w-full" variant={variant}>
        <Link href={createPath("course.show", { slug, id })}>
          <PlayIcon /> Przejdź do kursu
        </Link>
      </Button>
    );
  }

  if (exclusiveAccess) {
    return (
      <ExclusiveAccess
        exclusiveAccess={exclusiveAccess}
        link={createPath("course.show", { slug, id })}
      >
        <Button variant={variant} className="mt-4 w-full">
          <LockKeyholeOpenIcon /> Odblokuj dostęp
        </Button>
      </ExclusiveAccess>
    );
  }

  if (canBeBought) {
    return (
      <CourseCardCta
        product={product as ProductPriceOneVariantVM}
        name={title}
        preorder={preorder}
        variant={variant}
      />
    );
  }

  if (isFreebie) {
    return (
      <FreebieButton
        product={product as ProductPriceOneVariantVM}
        text="Odblokuj bezpłatnie"
        variant={variant}
      />
    );
  }

  return null;
};
